<template>
  <div class="tourListCassette">
    <div
      :class="[
        'tourListCassette_contentsArea',
        { '-recommended': tour.recommend_point === 1 },
      ]"
    >
      <div class="tourListCassette_titleArea">
        <tk-link
          class="tourListCassette_titleLink"
          :href="makeDetailPageUrl(tour.code)"
          target="_blank"
        >
          <div class="tourListCassette_title">
            {{ tour.title }}
          </div>
        </tk-link>
      </div>
      <div class="tourListCassette_imageArea">
        <tk-link :href="makeDetailPageUrl(tour.code)" target="_blank">
          <tk-image
            class="tourListCassette_image"
            :image-path="mainImage.path"
            :alt="mainImage.caption"
            lazy
            :lazy-loading-margin="300"
          />
        </tk-link>
        <tk-image
          v-if="tour.recommend_point === 1"
          class="tourListCassette_recommendationTag"
          :image-path="
            require('@ota-frontend/shared-assets/images/common/ico_recommend_tour.png')
          "
          alt="オススメpickup"
        />
        <div class="tourListCassette_underSentence">
          {{ underImageSentence }}
        </div>
        <div class="tourListCassette_carrierImage">
          <template v-if="tour.train">
            <div class="tourListCassette_multiCarrier">
              <tk-icon
                class="tourListCassette_multiCarrierIcon -train"
                name="train"
                color="white"
              />
            </div>
            <div class="tourListCassette_carrierImageText">
              {{ tour.train.code }}
            </div>
          </template>
          <template v-else-if="tour.air.condition === '0'">
            <div class="tourListCassette_multiCarrier">
              <tk-icon
                class="tourListCassette_multiCarrierIcon -plane"
                name="sideways_plane"
                color="white"
              />
            </div>
            <div class="tourListCassette_carrierImageText">未定</div>
          </template>
          <template v-else-if="tour.air.airlines.length === 1">
            <template v-if="existsCarrierImage">
              <tk-carrier-logo
                :code="tour.air.airlines[0].carrier_code"
                :style="[{ width: '75%' }, { height: 'auto' }]"
              />
            </template>
            <template v-else>
              <div class="tourListCassette_multiCarrier">
                <tk-icon
                  class="tourListCassette_multiCarrierIcon -plane"
                  name="sideways_plane"
                  color="white"
                />
              </div>
              <div class="tourListCassette_carrierImageText">
                {{ tour.air.airlines[0].carrier_name }}
              </div>
            </template>
          </template>
          <template v-else-if="tour.air.airlines.length > 1">
            <div class="tourListCassette_multiCarrier">
              <tk-icon
                class="tourListCassette_multiCarrierIcon -plane"
                name="sideways_plane"
                color="white"
              />
            </div>
            <div class="tourListCassette_carrierImageText">
              {{ tour.air.airlines[0].carrier_name }}等
            </div>
          </template>
        </div>
      </div>
      <tk-badges
        v-if="badges.length > 0"
        class="tourListCassette_badges"
        :items="badges"
      />
      <div
        :class="[
          'tourListCassette_mainContents',
          { '-extraMarginTop': mobile && !durationTabs },
        ]"
      >
        <tk-tabs
          v-if="durationTabs"
          nav-tabs-class="tourListCassette_similarTourTabs"
          active-class="active"
          content-class="tab-content"
          :active-tab-index="activeDurationTabIndex"
        >
          <tk-tab
            v-for="similarTour in similarTours"
            :key="similarTour.tourCode"
            :title="`${similarTour.duration}日間`"
          >
            <tour-list-cassette-main-contents
              class="tourListCassette_price -tab"
              :tour-code="similarTour.tourCode"
              :price="similarTour"
              :discounted="similarTour.discounted"
              :make-detail-page-url="makeDetailPageUrl"
            />
          </tk-tab>
        </tk-tabs>
        <template v-else>
          <tour-list-cassette-main-contents
            class="tourListCassette_price"
            :tour-code="tour.code"
            :price="tour.price"
            :discounted="tour.price.discounted"
            :make-detail-page-url="makeDetailPageUrl"
          />
        </template>
      </div>
      <tk-tooltips
        class="tourListCassette_overviewBoxArea"
        :trigger="mobile ? 'click' : 'hover'"
      >
        <template v-slot:tool>
          <div class="tourListCassette_overviewBox">
            <div class="tourListCassette_overviewBoxTextArea">
              {{ mobile ? '概要を見る' : 'ツアー概要をもっと見る' }}
              <tk-down-arrow
                class="tourListCassette_overviewBoxDownArrow"
                size="x-large"
              />
            </div>
          </div>
        </template>
        <template v-slot:tips>
          <div class="tourListCassette_tourSummaryHeaderArea">
            <span class="tourListCassette_tourSummaryHeader"
              >ツアーコード：{{
                tour.sale_type === 'offline' ? tour.code : tour.visitor_code
              }}</span
            >
          </div>
          <tour-summary
            class="tourListCassette_tourSummary"
            :tour="tour"
            icon-border
          />
        </template>
      </tk-tooltips>
    </div>
  </div>
</template>

<script>
import { uniq } from 'lodash'
import {
  /* [暫定]お気に入り非表示対応
  TkFavoriteButton,
  */
  TkBadges,
  TkDownArrow,
  TkImage,
  TkLink,
  TkTabs,
  TkTab,
  TkTooltips,
  TkCarrierLogo,
  TkIcon,
} from '@ota-frontend/ui'
import { Facets } from '@/models'
import TourSummary from '@/components/TourSummary'
import TourListCassetteMainContents from '@/modules/tour-list/components/TourListCassetteMainContents'

export default {
  name: 'TourListCassette',
  components: {
    /* [暫定]お気に入り非表示対応
    TkFavoriteButton,
    */
    TkBadges,
    TkDownArrow,
    TkImage,
    TkLink,
    TkTabs,
    TkTab,
    TkTooltips,
    TourSummary,
    TourListCassetteMainContents,
    TkCarrierLogo,
    TkIcon,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
    makeDetailPageUrl: {
      type: Function, // tourCode => url
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    facets: {
      type: Facets,
      required: true,
    },
    durationTabs: {
      type: String,
      default: 'always',
    },
  },
  data() {
    return {
      isDomestic: false,
      notRegisteredFavoriteMessage:
        window.innerWidth > 657 ? 'お気に入り登録' : '',
      registeredFavoriteMessage:
        window.innerWidth > 657 ? 'お気に入り登録済み' : '',
    }
  },
  computed: {
    mainImage() {
      return (
        this.tour.images.find((image) => image.order === 1) ||
        this.tour.images[0]
      )
    },
    underImageSentence() {
      return `${this.destinationText}（${this.tour.destinations[0].country_name}） ツアー${this.departureName}発 ${this.tour.duration}日間`
    },
    destinationText() {
      const formattedDestinations = this.tour.destinations
        .filter((d) => d.city_name)
        .map((d) =>
          d.district_name ? `${d.city_name}(${d.district_name})` : d.city_name
        )
      return uniq(formattedDestinations).join(',')
    },
    similarTours() {
      const mainTour = {
        tourId: '-1',
        tourCode: this.tour.code,
        duration: this.tour.duration,
        visitorCode: this.tour.visitor_code,
      }
      if (this.tour.price.min === this.tour.price.max) {
        mainTour.fixedPrice = this.tour.price.min
      } else {
        mainTour.minPrice = this.tour.price.min
        mainTour.maxPrice = this.tour.price.max
      }
      if (this.tour.price.discounted) {
        if (this.tour.price.discounted.min === this.tour.price.discounted.max) {
          mainTour.discounted = {
            fixedPrice: this.tour.price.discounted.min,
          }
        } else {
          mainTour.discounted = {
            minPrice: this.tour.price.discounted.min,
            maxPrice: this.tour.price.discounted.max,
          }
        }
      }

      return [...this.tour.similar_tours, mainTour]
        .map((tour) => ({
          ...tour,
          diffOfDuration: Math.abs(tour.duration - mainTour.duration),
        }))
        .sort((a, b) => (a.diffOfDuration > b.diffOfDuration ? 1 : -1))
        .slice(0, 5)
        .sort((a, b) => (a.duration > b.duration ? 1 : -1))
    },
    activeDurationTabIndex() {
      return this.similarTours.findIndex((s) => s.tourCode === this.tour.code)
    },
    badges() {
      return this.tour.intentions
        .filter((i) => this.facets.popularIntentionIds.includes(String(i.id)))
        .map((p) => ({ id: p.id, name: p.word }))
    },
    departureName() {
      const departureNames =
        this.tour.domestic && this.tour.train
          ? this.tour.departures_org.map((departure) => departure.name)
          : this.tour.departures.map((departure) => departure.name)
      const departureName = departureNames
        .join(',')
        .replace(/東京\(成田\)/g, '成田')
        .replace(/東京\(羽田\)/g, '羽田')
      return departureName
    },
    tourDetailText() {
      return this.mobile ? '概要を見る' : 'ツアー概要をもっと見る'
    },
    existsCarrierImage() {
      return TkCarrierLogo.AVAILABLE_CARRIERS.codes.includes(
        this.tour.air.airlines[0].carrier_code
      )
    },
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.tourListCassette {
  font-size: 11px;
  border-top: 0;
  border: 0;
  border-radius: 8px;
  color: #63666a;
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 8px;
  position: relative;
  box-sizing: border-box;
}

.tourListCassette_badges {
  grid-area: intention-badges;
  align-self: start;
  font-weight: bold;

  @media (max-width: 657px) {
    margin-top: 11px;
  }
}

.tourListCassette_imageArea {
  grid-area: image;
  position: relative;

  @media (max-width: 657px) {
    width: 100%;
  }
}

.tourListCassette_image {
  width: 100%;
  height: 224px;
  object-fit: cover;
  border-radius: 5px;

  @media (max-width: 657px) {
    height: 170px;
  }
}

.tourListCassette_carrierImage {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 11px;
  right: 11px;
  height: 21px;
  border-radius: 2em;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.5) 2px 2px 2px;
}

.tourListCassette_multiCarrier {
  position: relative;
  width: 23px;
  height: 21px;
  display: inline-block;
  background-color: #63666a;
  border-radius: 2em 0 0 2em;
}

.tourListCassette_multiCarrierIcon {
  position: absolute;
  height: auto;

  &.-train {
    left: 8px;
    top: 4px;
    width: 10px;
  }

  &.-plane {
    left: 7px;
    top: 7px;
    width: 12px;
  }
}

.tourListCassette_carrierImageText {
  padding-top: 1px;
  padding-left: 5px;
  padding-right: 10px;
  font-size: 11px;
}

.tourListCassette_underSentence {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px;
  border-radius: 0 0 5px 5px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 14px;
}

.tourListCassette_contentsArea {
  display: grid;
  gap: 9px;
  padding: 15px 14px 5px;

  grid-template-rows: repeat(4, auto);
  grid-template-columns: 266fr 280fr;
  grid-template-areas:
    'title title'
    'image intention-badges'
    'image main-contents'
    'detail detail';

  &.-recommended {
    height: auto;
    min-height: 270px;
    padding: 12px 11px 2px;
    border-radius: 8px;
    border: 4px solid #ffd200;
  }

  @media (max-width: 657px) {
    padding: 3px 11px 5px;

    &.-recommended {
      padding: 0 8px 2px;
    }

    grid-template-rows: repeat(5, auto);
    grid-template-columns: 1fr;
    grid-template-areas:
      'intention-badges'
      'image'
      'title'
      'main-contents'
      'detail';
  }
}

.tourListCassette_titleArea {
  grid-area: title;
  overflow: hidden;
  margin: auto;

  @media (max-width: 657px) {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
  }
}

.tourListCassette_titleLink {
  color: #333333;
}

.tourListCassette_title {
  margin: 0;
  height: auto;
  position: relative;
  padding: 0;
  text-decoration-line: none;
  text-decoration-style: initial;
  text-decoration-color: initial;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0.4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-decoration: underline;

  @media (max-width: 657px) {
    font-size: 15px;
    -webkit-line-clamp: 3;
  }
}

.tourListCassette_mainContents {
  grid-area: main-contents;
  align-self: end;
  padding-bottom: 4px;

  &.-extraMarginTop {
    margin-top: 5px;
  }
}

.tourListCassette_price {
  margin-top: 12px;

  @media (max-width: 657px) {
    margin-top: 2px;

    &.-tab {
      margin-top: 12px;
    }
  }
}

.tourListCassette_overviewBoxArea {
  position: relative;
  grid-area: detail;
}

.tourListCassette_overviewBox {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #d2d2d2;
  font-size: 14px;
  font-weight: bold;
  padding: 12px 22px;
  cursor: pointer;
  height: 46px;
  letter-spacing: 0.7px;

  @media (max-width: 657px) {
    height: 37px;
    border-top: unset;
  }
}

.tourListCassette_overviewBoxTextArea {
  position: relative;
  display: flex;
}

.tourListCassette_overviewBoxDownArrow {
  position: relative;
  margin-left: 15px;
  color: #d2d2d2;

  @media (max-width: 657px) {
    margin-left: 8px;
  }
}

.tourListCassette_tourSummaryHeaderArea {
  display: table;
  width: 509px;
  height: 44px;
  padding: 0 18px;
  background-color: #dedfdf;
  font-size: 13px;

  @media (max-width: 657px) {
    width: 320px;
  }
}

.tourListCassette_tourSummaryHeader {
  display: table-cell;
  vertical-align: middle;
}

.tourListCassette_tourSummary {
  width: 509px;
  padding: 16px;
  background-color: white;

  @media (max-width: 657px) {
    width: 320px;
  }
}

.tourListCassette_recommendationTag {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 60px;
  height: 60px;
  z-index: 1;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.5));
}
</style>

<style lang="scss">
.tourListCassette_similarTourTabs {
  display: flex;
  width: 100%;
  padding: 0 5px;
  border-bottom: solid 1px #d2d2d2;
  position: relative;

  & li {
    border-radius: 4px 4px 0 0;
    background: #e7e7e7;
    border: 1px solid #d2d2d2;
    border-bottom: none;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    padding: 10px 0;
    width: 18%;
    margin-right: 1%;
    font-size: 13px;
    float: left;
    cursor: pointer;

    &.active {
      background: white;
      color: #333;
      border-bottom: none;
      font-weight: bold;
      position: relative;
      top: 1px;
    }

    @media (max-width: 657px) {
      width: 15%;
    }
  }
}
</style>
